export const skills = [
    {
      title: "Frontend",
      skills: [

        
        {
          name: "ReactJS",
          image: "https://github.com/Dhananjaywarade/logo/blob/main/frontend/React-icon.svg.png?raw=true",
        },
      
        {
          name: "HTML",
          image: "https://github.com/Dhananjaywarade/logo/blob/main/frontend/html5-badge-h-solo.png?raw=true",
        },
        {
          name: "CSS",
          image:
            "https://github.com/Dhananjaywarade/logo/blob/main/frontend/CSS3_logo_and_wordmark.svg.png?raw=true",
        },
        {
          name: "JavaScript",
          image:
            "https://github.com/Dhananjaywarade/logo/blob/main/frontend/JavaScript-logo.png?raw=true",
        },
        {
          name: "Bootstrap",
          image:
            "https://github.com/Dhananjaywarade/logo/blob/main/frontend/bootstrap-logo-shadow.png?raw=true",
        },
       
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://github.com/Dhananjaywarade/logo/blob/main/backend/nodejs.png?raw=true",
        },
        {
          name: "Express Js",
          image:
            "https://github.com/Dhananjaywarade/logo/blob/main/backend/expressjs.png?raw=true",
        },
       
       
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/Dhananjaywarade/logo/9b9d9e930d96e33b1b6fd5ce47c1b1df5cd640d6/backend/mysql-original-wordmark.svg",
        },
        
        {
          name: "Spring Boot",
          image: "https://raw.githubusercontent.com/Dhananjaywarade/logo/9b9d9e930d96e33b1b6fd5ce47c1b1df5cd640d6/backend/spring-initializr.svg",
        }
        
      ],
    },
    {
      title: "Android",
      skills: [
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/Dhananjaywarade/logo/0467f2dfe7f2565775b313262089a17267fc3461/android/java-original.svg",
        },

        
        {
          name: "XML",
          image:
            "https://github.com/Dhananjaywarade/logo/blob/main/android/xml.png?raw=true",
        },
       
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://github.com/Dhananjaywarade/logo/blob/main/others/gitupdated.png?raw=true",
        },
        {
          name: "GitHub",
          image:
            "https://github.com/Dhananjaywarade/logo/blob/main/others/GitHub-Mark.png?raw=true",
        },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/Dhananjaywarade/logo/06de8a2e2f49516ded1a2decbda9f02626b803f4/others/docker-original-wordmark.svg",
        },
        {
          name: "Netlify",
          image:
            "https://github.com/Dhananjaywarade/logo/blob/main/others/netlify-logo-BD8F8A77E2-seeklogo.com.png?raw=true",
        },
        {
          name: "VS Code",
          image:
            "https://github.com/Dhananjaywarade/logo/blob/main/others/Visual_Studio_Code_1.35_icon.svg.png?raw=true",
        },
        {
          name: "Postman",
          image:
            "https://github.com/Dhananjaywarade/logo/blob/main/others/postman.png?raw=true",
        },
        
        
      ],
    },
  ];

  export const education = [
    {
      id: 0,
      img: "https://github.com/Dhananjaywarade/logo/blob/main/education/sunbeam.jpg?raw=true",
      school: "SunBeam Institute of Information Technology, Pune",
      date: "March 2023 - Aug 2023",
      desc: "I have successfully completed my postgraduate diploma in advanced computing from SunBeam Institute of Information Technology in Pune. My skillset includes proficiency in the following areas: Postman API, Front-End Design, Responsive Web Design, Web Design, Front-End Development, Spring Framework, MySQL, HTML, Cascading Style Sheets (CSS), JavaScript, React.js, Node.js, C++, Object-Oriented Programming (OOP), Data Structures, and Bootstrap.",
      degree: "Postgraduate Diploma, Diploma In Advanced Computing (DAC)",
    },
    {
      id: 1,
      img: "https://github.com/Dhananjaywarade/logo/blob/main/education/gcoea.jpg?raw=true",
      school: "Government College of Engineering, Amravati",
      date: "Aug 2018 - Aug 2022",
      desc: "I spent the best 4 years at this college. It helped me explore my potential, thanks to the lenient curriculum and no hard attendance rules that I got ample time to dive into new domains and try new ventures.",
      degree: "Bachelor of Technology (B.Tech) in Mechanical Engineering",
    },
    {
      id: 2,
      img: "https://github.com/Dhananjaywarade/logo/blob/main/education/babanrao.jpg?raw=true",
      school: "Late. Babanrao Deshpande High School And Junior College Motala ",
      date: "Apr 2017 - March 2018",
      desc: "I completed my class 12 education at Late. Babanrao Deshpande High School And Junior College Motala.",
      degree: "Higher Secondary Certificate (HSC) in Science",
    },
    {
      id: 3,
      img: "https://github.com/Dhananjaywarade/logo/blob/main/education/babanrao.jpg?raw=true",
      school: "Late. Babanrao Deshpande High School And Junior College Motala ",
      date: "Apr 2015 - March 2016",
      desc: "I completed my class 10 education at Late. Babanrao Deshpande High School And Junior College Motala.",
      degree: "Secondary School Certificate (SSC)",
    },
  ];
  
  
  export const experience = [
   
    {
      id: 0,
      img: "./images/brose.png",
      company: "Brose India",
      date: "Oct. 2024 - Present",  
      desc:"I am actively contributing to the development and maintenance of three key enterprise modules — SpindleCockpit, DoorDriveAssistant, and BMA Tool — focusing on both feature implementation and bug fixing. Leveraging technologies like C#, WPF, LINQ, SQL, and ASP.NET MVC, I build robust and scalable backend and frontend solutions. I write optimized SQL queries and LINQ expressions to ensure efficient data access, while maintaining high-quality UI/UX using the MVVM architecture in WPF. Collaborating closely with senior developers, I work to continuously improve application performance, reliability, and scalability across all modules.",
      role: "Software Developer",
      skills: [
        "C#",
        "WPF",
        "LINQ",
        "SQL",
        "ASP.NET MVC",
        "MVVM Architecture",
        "UI/UX Design",
        "ASP.NET",
      ],
    },
    {
      id: 1,
      img: "./images/Nextech.png",
      company: "NexTech PLM Solutions Pvt. Ltd",
      date: "Jun. 2024 - Sep. 2024",
      desc:"As a full-stack developer, I developed a company website from scratch, focusing on creating a seamless and efficient user experience. For the frontend, I utilized ReactJS, leveraging its component-based architecture to deliver a responsive and interactive interface, while the backend was powered by Node.js, ensuring a scalable and high-performance server-side environment. This combination allowed the website to meet modern web standards, optimize loading times, and provide a visually engaging, user-friendly experience tailored to business needs.",
      role: "Teamcenter Solutions Developer",
      skills: [
        "ReactJS",
        "NodeJS",
        
      ],
    },
  
  ]
  
  export const projects = [
    {
      id: 9,
      title: "Food Ordering System",
      date: "Feb 2024 - April 2024",
      description:
        "Experience the future of food ordering with our cutting-edge Food Ordering System, developed by our dedicated team. Utilizing a microservices architecture, we ensure scalability and flexibility to meet your growing needs. Seamlessly integrating Spring Boot and React.js, our system delivers a smooth user experience from front-end to back-end. We prioritize data integrity with efficient management using MySQL and MongoDB. Our deployment of service discovery with Eureka server enhances system performance, guaranteeing uninterrupted service. With MapStruct integration, we optimize data handling, ensuring smooth mapping between DTOs and entities. Trust us to revolutionize your food ordering experience. ",
      image:
        "https://github.com/Dhananjaywarade/logo/blob/main/foodDelivery.png?raw=true",
      tags: [
        "Spring Boot",
        "MongoDb",
        "MySQL",
        "Microservices",
        "React Js",
      ],
      github: "https://github.com/orgs/DoorDashFoodDelivery/repositories",
      webapp: "",
      member: [
        {
          name: "Dhananjay warade",
          img: "https://avatars.githubusercontent.com/u/98320131?v=4",
          linkedin: "https://www.linkedin.com/in/dhananjaywarade/",
          github: "https://github.com/Dhananjaywarade",
        },
        {
          name: "Sudhanshu Kulkarni",
          img: "./images/sudhanshukulkarni.png",
          linkedin: "https://www.linkedin.com/in/sudhanshu98kulkarni/",
          github: "https://github.com/sudhanshukulkarni98",
        },
      ],
    },
    {
      id: 0,
      title: "ECommerce Website",
      date: "July 2023 - Aug 2023",
      description:
        "Discover our eCommerce platform, akin to Flipkart, offering seamless browsing, order placement, and seller management. Our user-friendly interface simplifies shopping, cart management, and order processing. Sellers benefit from a secure portal for efficient product management and order fulfillment. Experience hassle-free online shopping and selling with us.",
      image:
        "https://github.com/Dhananjaywarade/logo/blob/main/ecommerce.png?raw=true",
      tags: ["React Js", "MySQL", "Node Js", "Express Js", "Spring Boot", "Hibernate"],
      
      github: "https://github.com/ayush-chothe/eCommerce",
      webapp: "",
     
    },
    {
      id: 1,
      title: "Weather Website",
      date: "Oct 2023 - Nov 2023",
      description:
        "I developed a user-friendly platform that delivers accurate weather information for any location by designing and implementing a responsive and visually engaging website. Leveraging APIs, the platform seamlessly fetches real-time weather data, ensuring users have access to the most up-to-date forecasts and conditions. The website's intuitive interface simplifies navigation, enabling users to effortlessly obtain the weather information they need, enhancing their overall experience and usability.",
      image:
        "https://github.com/Dhananjaywarade/logo/blob/main/Untitled%20design.png?raw=true",
      tags: [
        "HTML",
        "CSS",
        "JavaScript",
      ],
      github: "https://github.com/Dhananjaywarade/weather",
      webapp: "https://dhananjaywarade.github.io/weather/",
      
     
    },
   
  ];